<template>
  <dir>
    <div v-if="list.length" class="container">
      <div class="notice-icon">
        <van-icon name="volume-o" />
      </div>

      <div class="notice-title">最新公告:</div>

      <van-swipe class="notice-content" vertical :autoplay="3000" :show-indicators="false" :touchable="false">
        <van-swipe-item v-for="(item, index) in list" :key="index" class="item">{{ item }}</van-swipe-item>
      </van-swipe>
    </div>

    <iain-gap v-else height="20"/>
  </dir>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  align-items: center;
  padding: 0 30px;
  line-height: 68px;
  background-color: rgba(248, 248, 248, 1);

  .notice-icon {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    padding-right: 10px;
    height: 68px;
  }

  .notice-title {
    flex-shrink: 0;
    padding-right: 10px;
    height: 68px;
    font-size: 24px;
    color: #212121;
  }

  .notice-content {
    flex-grow: 1;
    height: 68px;

    .item {
      width: 600px;
      font-size: 24px;
      color: #212121;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
